<button class="pill-button" [class.no-hover]="noHover" (click)="buttonClick.emit()">
  @if (image) {
    <tidy-image
      [src]="image"
      class="pill-button-icon no-right-margin" />
  }
  @if (text) {
    <span class="pill-button-text">{{ text | translate }}</span>
  }
</button>
